import { Button } from "@mui/material";
import { useDownloadTransactionsExportMutation } from "Api/Mutations/Transactions/useDownloadTransactionsExportMutation";
import { Resources, useResource } from "Translations/Resources";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

type Props = {
  fileNamePrefix: string;
  userID: number;
};

export const ExportTransactionsButton = ({ fileNamePrefix, userID }: Props) => {
  const { mutate: downloadTransactionsExport, isPending: isDownloadPending } =
    useDownloadTransactionsExportMutation();
  const { t } = useResource();

  return (
    <Button
      fullWidth
      sx={{ py: 4 }}
      color="info"
      type="button"
      variant="outlined"
      disabled={isDownloadPending}
      endIcon={<FileDownloadOutlinedIcon />}
      onClick={() => downloadTransactionsExport({ fileNamePrefix, userID })}
    >
      {t(Resources.Components.Transactions.Export)}
    </Button>
  );
};
